// extracted by mini-css-extract-plugin
export var header = "_t0-1";
export var maskBottom = "_t0-6";
export var maskMiddle = "_t0-7";
export var maskTop = "_t0-5";
export var root = "_t0-0";
export var scrollDownButton = "_t0-3";
export var scrollDownButtonHidden = "_t0-4";
export var viewport = "_t0-2";